
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const ApplicationLoadingState: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="max-w-2xl mx-auto">
        <CardContent className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <span className="ml-2">Checking existing applications...</span>
        </CardContent>
      </Card>
    </div>
  );
};

export default ApplicationLoadingState;
